export default "__VITE_ASSET__b1WSwPWS__"